import { render } from "./VerExpedienteAudit.vue?vue&type=template&id=d79b2cde&scoped=true"
import script from "./VerExpedienteAudit.vue?vue&type=script&lang=js"
export * from "./VerExpedienteAudit.vue?vue&type=script&lang=js"

import "./VerExpedienteAudit.vue?vue&type=style&index=0&id=d79b2cde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d79b2cde"]])

export default __exports__